import FingerprintJS from '@fingerprintjs/fingerprintjs';

let fpPromise = null;
let getPromise = null;

export const loadFingerprint = () => {
  if (!fpPromise) {
    fpPromise = FingerprintJS.load();
  }
  return fpPromise;
};

export const getFingerprint = () => {
  if (!getPromise) {
    getPromise = (async () => {
      const fp = await loadFingerprint();
      const result = await fp.get();
      return result.visitorId;
    })();
  }
  return getPromise;
};
